import { render, staticRenderFns } from "./GalleryFolderLogo.vue?vue&type=template&id=23d126a9&scoped=true"
import script from "./GalleryFolderLogo.vue?vue&type=script&lang=js"
export * from "./GalleryFolderLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d126a9",
  null
  
)

export default component.exports